import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
// import SearchResults from "../views/SearchResults.vue";
// import Event from "../views/Event.vue";
// import Transaction from "../views/Transaction.vue";
import TransactionDetails from "../views/TransactionDetails.vue";
import TokenExplorer from "../views/TokenExplorer.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  // {
  //   path: "/event",
  //   name: "Event",
  //   component: Event,
  // },
  // {
  //   path: "/transaction",
  //   name: "Transaction",
  //   component: Transaction,
  // },
  {
    path: "/transaction/:net/:hash",
    name: "TransactionDetails",
    props: true,
    component: TransactionDetails,
  },
  {
    path: "/token-explorer",
    name: "TokenExplorer",
    props: true,
    component: TokenExplorer,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
